import {FULFILLED} from 'redux-promise-middleware';

import {STEPS} from '../../constants/constants';

export const FacesFixture = [
    {
        id: 1524515,
        url:
            'https://m.glassesusa.local/media/mirror/photo/src/0/05/13813503e4352330ebfdbeae2ae4c2f2.jpg',
        is_current: false,
        model:
            'https://m.glassesusa.local/media/mirror/photo/cache/0/05/resized_76_13813503e4352330ebfdbeae2ae4c2f2.jpg',
        pupils: {
            right: {
                x: 176,
                y: 168,
            },
            left: {
                x: 90,
                y: 178,
            },
        },
        is_user_photo: true,
        gender: 0,
        pd: 62,
    },
    {
        id: 1248962,
        url:
            'https://m.glassesusa.local/media/mirror/photo/src/0/05/80ce842c920e6f6cc6754793414e9b76.jpg',
        is_current: true,
        model:
            'https://m.glassesusa.local/media/mirror/photo/cache/0/05/resized_76_80ce842c920e6f6cc6754793414e9b76.jpg',
        pupils: {
            right: {
                x: 177,
                y: 165,
            },
            left: {
                x: 107,
                y: 165,
            },
        },
        is_user_photo: false,
        gender: 1,
        pd: 63,
    },
];

export const TryOnCollectionFixture = {
    faces: FacesFixture,
    productInfo: {
        id: '7134',
        name: 'Elliot Black w/Gold',
        link: '/blackgold-medium/elliot/31-m10033.html',
    },
    pd: 62,
    isVisibility: true,
    currentStep: STEPS.INITIAL,
    status: FULFILLED,
};
